import { useDispatch, useSelector } from 'react-redux';
import { get, first } from 'global/lib/lodash';
import { useEffect, useState } from 'react';
import arrayToTree from 'array-to-tree';
import isLoggedIn from 'global/utils/isLoggedIn';
import { ALLREALMS } from '../components/droprealms';
import setUserRealm from 'redux/actions/userRealm';

export const useUser = (props) => {
  const auth = useSelector(state => state.auth);
  const me = get(auth, 'user');
  const realm = get(auth, 'realm');
  const realms = get(auth, 'user.realms');
  const dispatch = useDispatch();
  
  const [state, setState] = useState({
    parentRealm: {},
    chartRealm: {},
    libRealm: {},
    onlyOneDivision: false,
  })

  const realmOrUserRealm = realm || get(me, 'realm');

  useEffect(() => {
    if (!Array.isArray(realms)) { return }

    const list = arrayToTree([me.realm, ...realms], { parentProperty: 'parentId' });

    const pr = get(list, '0.children.0', realmOrUserRealm);

    setState(s => ({ ...s, parentRealm: pr }))
  }, [realms]);

  useEffect(() => {
    if (realmOrUserRealm) {
      const chartRealm = get(realmOrUserRealm, 'topDivision', get(me, 'highestRealm', realmOrUserRealm));

      setState(s => ({ ...s, chartRealm, libRealm: chartRealm.tier === 'division' || get(chartRealm, 'tier') === 'builder' ? chartRealm : s.parentRealm }))
    }
  }, [realmOrUserRealm, state.parentRealm]);

  useEffect(() => {
    if (me && me.realms) {
      const found = [];
      for (let i = 0; i < me.realms.length; i++) {
        const r = me.realms[i];
        if (r.tier === 'division') {
          found.push(r);
        }
  
        if (found.length >= 2) {
          break;
        }
      }
  
      if (found.length == 1) {
        setState(s => ({ ...s, onlyOneDivision: first(found) }));
        if (get(props, 'setContextWhenOneDivision')) {
          dispatch(setUserRealm(first(found)))
        }
      }
    }
  }, [get(me, 'realms')])

  return {
    me,
    loggedIn: isLoggedIn(auth),
    realm: realm,
    userRealm: get(me, 'realm', {}),
    realmOrUserRealm,
    ...state,
    libRealm: state.onlyOneDivision || state.libRealm,
    reportRealm: state.libRealm,
    highestRealm: realm || state.parentRealm,
    chartRealm: realm || state.chartRealm,
    allrealms: ALLREALMS,
    selectedRealmBuilder: get(realmOrUserRealm, 'topRealm', get(me, 'realm', {})),
  };
};
